import { AlertCircle } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center max-w-sm mx-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-600 text-center">
          Connecting to AI Coach...
        </p>
      </div>
    </div>
  );
}

export function LoadingFeedback() {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center max-w-sm mx-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-600 text-center">
          Generating the session summary ...
        </p>
      </div>
    </div>
  );
}

export function ErrorMessage({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center max-w-sm mx-4">
        <AlertCircle className="w-12 h-12 text-red-500" />
        <h3 className="mt-4 text-lg font-semibold text-gray-900">
          Connection Error
        </h3>
        <p className="mt-2 text-gray-600 text-center">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-600 transition-colors"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}
